import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router';
import { useCommonStyles, useStores } from '../../../common/hooks';
import { AcceptItem } from '../../../models';
import { RoutePaths } from '../../../route-paths';

interface AcceptItemProps {
  onAgreeButtonClick: (acceptItem: AcceptItem) => void;
}

const AcceptItemModalImpl: React.FC<AcceptItemProps> = (props) => {
  const {
    onAgreeButtonClick
  } = props;

  const {
    selectAwardPageUiStore
  } = useStores();

  const commonStyles = useCommonStyles();

  const renderAcceptItemContents = (): React.JSX.Element[] => {
    const acceptItemParagraphs = selectAwardPageUiStore.currentAcceptItem.content.split('\n');
    return acceptItemParagraphs.map((paragraph, index) => (
      <p key={index}>
        {paragraph}
      </p>
    ));
  };

  const handleAgreeButtonClick = (acceptItem: AcceptItem) => {
    onAgreeButtonClick(acceptItem);
    selectAwardPageUiStore.nextProgress();
  };

  if (!selectAwardPageUiStore.currentAcceptItem) return <></>;

  return (
    <Dialog
      defaultOpen
    >
      <DialogSurface className={commonStyles.modalSurface}>
        <DialogBody className={commonStyles.modalBody}>
          <DialogTitle>
            {selectAwardPageUiStore.currentAcceptItem.acceptItemTypeName}
          </DialogTitle>
          <DialogContent>
            {renderAcceptItemContents()}
          </DialogContent>
          <DialogActions>
            <Link
              to={RoutePaths.Home}
              className='secondary-btn'
            >
              Back
            </Link>

            <Button
              appearance='primary'
              onClick={() => handleAgreeButtonClick(selectAwardPageUiStore.currentAcceptItem)}
            >
              I agree
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export const AcceptItemModal = observer(AcceptItemModalImpl);